import { useMemo } from "react";
import clsx from "clsx";

import { useAppContext } from "@/hooks/useAppContext";

type AppImageSpecified = {
  vertical: string;
  icon: string;
  full: string;
  alt: string;
};

type AppImgTypes = keyof Omit<AppImageSpecified, 'alt'>;

export type AppImgProps = {
  className?: HTMLElement['className'];
  type?: AppImgTypes;
};

export type AppImageComponentType = React.ComponentType<AppImgProps>;

export function AppImage({ type, className }: AppImgProps) {
  const { appType } = useAppContext();

  const appImg: AppImageSpecified = useMemo(() => {
    switch (appType) {
      case 'viber-uzenetek':
        return {
          vertical: '/vbm-vertical-title.png',
          icon: '/vbm.png',
          full: '/vbm-vertical.png',
          alt: 'Viber Üzenetek',
        };
      default:
        return {
          vertical: '/cc_vertical_title.png',
          icon: '/cc_vertical_128.png',
          full: '/cc_vertical.svg',
          alt: 'ConversionCraft',
        };
    }
  }, [appType]);

  return (
    <img src={appImg[type ?? 'full']} alt={appImg.alt} className={clsx(className)} />
  );
}